import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import Select from 'react-select';

const DefaultSelect = (props) => {
  const customProps = () => {
    if (props['data-testid']) return { 'data-testid': props['data-testid'] };
    if (typeof props.validation !== 'object') return {};
    const localValidation = props.validation.find(v => v.key === props.inputName);

    if (!localValidation) return {};
    return localValidation.valid ? { valid: true } : { invalid: true };
  };

  const options = [{value: -1, label: 'Selecione...'}, ...props.options];

  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      defaultValue={options[0]}
      name={props.inputName}
      id={props.inputName}
      options={options}
      value={options.find(opt => opt.value === props.selected)}
      onChange={(selected) => props.onChange(props.inputName, selected)}
      { ...customProps() }
    />
  );
};

const CustomSelect = (props) => {
  return (
    <FormGroup>
      <Label for={props.inputName}>{props.labelText}</Label>
      <DefaultSelect {...props} />
    </FormGroup>
  );
};

CustomSelect.propTypes = {
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validation: PropTypes.array
};

export default CustomSelect;
